export const IDENTITIES_RESOURCE = 'identities';
export const ANONYMIZE_IDENTITY_RESOURCE = 'anonymizeIdentity';
export const INFINITE_SCROLL = { loader: 'blocked' };
